import { render, staticRenderFns } from "./ProjectInRevisionList.vue?vue&type=template&id=7c21aab0&scoped=true&"
import script from "./ProjectInRevisionList.vue?vue&type=script&lang=js&"
export * from "./ProjectInRevisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c21aab0",
  null
  
)

export default component.exports